import MobileVendor from './MobileVendor.component';

export default MobileVendor;
